<template>
  <div class="main-content">
    <!--    <SelectOrdersMap-->
    <!--      v-if="divId"-->
    <!--      :divisionId="divId"-->
    <!--      :chiefRunner="isUserChiefRunner()"-->
    <!--      :noAction="1"-->
    <!--    />-->
    <ManageOrdersMap
      v-if="divId"
      :divisionId="divId"
      :chiefRunner="isUserChiefRunner()"
      :noAction="1"
    />
  </div>
</template>

<script>

import SelectOrdersMap from "@/components/map/SelectOrdersMap.vue";
import ManageOrdersMap from "@/components/map/ManageOrdersMap.vue";

export default {
  components: {ManageOrdersMap, SelectOrdersMap},
  data() {
    return {
      divId: null,
    }
  },
  created() {
    this.divId = Object.values(this.$UserDetails).find((d) => d.alias === 'division_id')?.details;
    // this.divId = Object.values(this.$AllDivisions).find((d) => d.is_active && d.user_id === +this.$currentUID)?.id;
  },
  methods: {
    isUserChiefRunner() {
      return this.$currentUserRoles.includes('chiefRunner');
    }
  }
}

</script>
